import React, { useEffect, useState } from "react"
import "./Loader.css"
import bulb from "../assets/bulb.png"

const Loader = () => {

    const [running, setRunning] = useState(false)
    const [isEnded, setIsEnded] = useState(false)
    const [isAlmostLoaded, setIsAlmostLoaded] = useState(false)
    const loaderDuration = 3000  

    
    
    useEffect(() => {
    
        let end

        const timeout = setTimeout(() => {
    
            setRunning(true)
            end = setTimeout(() => {
                setIsEnded(true)
            }, 1000)
            document.body.style.overflow = `auto`
            window.scrollTo(0, 0)

        }, loaderDuration)

        const bulb = setTimeout(() => {
            setIsAlmostLoaded(true)
        }, loaderDuration - 1000)
    
        return () => {
            clearTimeout(timeout)
            clearTimeout(bulb)
            clearTimeout(end)
        }
            
    }, [])

    return (
        <React.Fragment>
            {!isEnded && (
                <div className={`loader_container ${running ? "translate-container-loader" : ""}`}>
                <div className={`child_loader_container`}>
                
                    <div>
                        <div className={`loader_logo_container ${running ? "opacity-0" : "opacity-100"}`}>

                        <svg width="200" height="200" viewBox="0 0 200 200" className="spin_loader" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="b" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stopColor="#a3d65c"/><stop offset="100%" stopColor="#159d8d"/></linearGradient><linearGradient id="a" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stopColor="#159d8d"/><stop offset="100%" stopColor="#5fd4f4"/></linearGradient></defs><path d="M100 30a70 70 0 0 1 70 70 70 70 0 0 1-70 70m-70-70a70 70 0 0 1 70-70" stroke="url(#a)" strokeWidth="10" fill="none"/><path d="M155 100a55 55 0 0 1-55 55 55 55 0 0 1-55-55 55 55 0 0 1 55-55" stroke="url(#b)" strokeWidth="10" fill="none"/></svg>

                            <div className="bulb">
                                <img id="bulb_image" src={bulb} alt="Logo" className={`${isAlmostLoaded ? "grayscale-0" : "grayscale"}`}></img>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
            )}
        </React.Fragment>
    )
}

export default Loader